const TITLE_MAP = new Map([
  ["", "登录"],
  ["/home/statisticsAnalysis", "统计分析"],
]);

// 获取token
function getToken() {
  return JSON.parse(sessionStorage.getItem("user-login"))?.data?.accessToken || "";
}

// 根据请求路径获得文档标签
function getTitle(path) {
  return TITLE_MAP.get(path) || "文明城市管理系统";
}

// 日期格式化
let formatDate = (v) => {
  let date = new Date(v);
  if (Number.isNaN(Number(date))) {
    date = new Date();
  }
  let y = date.getFullYear();
  let mon = (date.getMonth() + 1 + "").padStart(2, "0");
  let d = (date.getDate() + "").padStart(2, "0");
  let h = (date.getHours() + "").padStart(2, "0");
  let min = (date.getMinutes() + "").padStart(2, "0");
  let s = (date.getSeconds() + "").padStart(2, "0");
  return [y, mon, d].join("-") + " " + [h, min, s].join(":");
};

export { getToken, getTitle, formatDate };
